module.exports = __webpack_public_path__ + "static/10-7f41c3ff66f7d983854b81d64992b8ff.jpeg";